import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GamesRepositoryService } from "../../games/games-repository.service";
import { NgClass } from "@angular/common";
import { GameCelebrationService } from "../../games/services/game-celebration.service";

@Component({
    selector: "app-rapid-fire-animation",
    templateUrl: "./rapid-fire-animation.component.html",
    styleUrls: ["./rapid-fire-animation.component.scss"],
    standalone: true,
    imports: [NgClass],
})
export class RapidFireAnimationComponent implements OnInit {
  userProfilePic: string;
  public XpsValues: Data;
  public eventName: Data;
  public currentCelebrationData: Data;
  userId: string;
  constructor(
    private matDailogRef: MatDialogRef<RapidFireAnimationComponent>,
    private authService: AuthService,
    private gameRepoService: GamesRepositoryService,
    private gameCelebrationService: GameCelebrationService
  ) {
    // This method has been use to get the userProfile image from the userDetails collection
    this.authService.userDetails$
      .pipe(
        // Handling the error before subscribing to the data
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe((data) => {
        try {
          // This variable profile image URL
          this.userProfilePic = data?.profile_picture;
        } catch (error) {
          return throwError(error);
        }
      });
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("RapidFireAnimationComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    // This method has been used to get xps data
    this.authService
      .getAngularFireStore(
        `users/${this.userId}/gamification/celebrations/xp/details`,
        "snapshotChanges"
      )
      .pipe(
        map((res: Data) => {
          const data = res?.payload?.data();
          this.eventName = data?.event_name;
          return data;
        }),
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe((res: Data) => {
        // Handling the error
        try {
          // This variable contain XPS Value
          this.XpsValues = res?.details;
        } catch (error) {
          return throwError(error);
        }
      });
    setTimeout(() => {
      // This method has been used to close the dialog
      this.matDailogRef.close();
      // Update the presented = true node in the Xps document
      this.gameCelebrationService.updateXpsDocument();
      // Update the processed_status = true node in the current_celebration document
      this.gameCelebrationService.updateCurrentCelebrationDocument();
    }, 5000);
  }
}
